import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b969f626"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section manuals" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "thead-dark" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Make", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Model", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Serial No.", -1))
const _hoisted_8 = {
  key: 0,
  width: "10%"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "5%" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
], -1))
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = ["onUpdate:modelValue", "onChange"]
const _hoisted_12 = ["onUpdate:modelValue", "onChange"]
const _hoisted_13 = ["onUpdate:modelValue", "onChange"]
const _hoisted_14 = {
  key: 0,
  class: "text-center"
}
const _hoisted_15 = ["onClick", "checked"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "seen" }, "Seen", -1))
const _hoisted_17 = ["onClick", "checked"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "not_seen" }, "Not Seen", -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import { computed, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { Report, Manual } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'Manuals',
  setup(__props) {

const actProperty: any = inject('actProperty');

// Vuex Store
const store = useStore();

// Computed properties and methods
const report = computed((): Report => store.getters['reports/current']);

const manuals = computed({
  get: (): Manual[] => report.value.manuals,
  set: (data: Manual[]) => setReportDeep({ path: 'manuals', data })
});

const setReportDeep = (payload: {path: string, data: any}): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};

const isCheckOut = () => report.value.type == 'checkout';

const addNewManual = () => {
  manuals.value = [...manuals.value, new Manual()];
};

const removeManual = (index: number) => {
  actProperty.confirmPrompt()
      .then(() => manuals.value = actProperty.removeItemByIndex(manuals.value, index));
};

const setManualInteractedAndSeen = (manual: Manual,index:Number) => {
  manual.interacted = true;
  manual.seen = true;
  editManuals(manual,index);
};

const setManualInteractedAndNotSeen = (manual: Manual,index:Number) => {
  manual.interacted = true;
  manual.seen = false;
  editManuals(manual,index);
};
const editManuals = (manual:Manual,index:Number) => {
 setReportDeep({
    path: `manuals[${index}]`,
    data:manual
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          (isCheckOut())
            ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Seen"))
            : _createCommentVNode("", true),
          _hoisted_9
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manuals.value, (manual, $index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: manual._uuid
          }, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((manual.name) = $event),
                class: "form-control form-control-sm",
                size: "10",
                onChange: ($event: any) => (editManuals(manual,$index))
              }, null, 40, _hoisted_10), [
                [
                  _vModelText,
                  manual.name,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((manual.make) = $event),
                class: "form-control form-control-sm",
                size: "10",
                onChange: ($event: any) => (editManuals(manual,$index))
              }, null, 40, _hoisted_11), [
                [
                  _vModelText,
                  manual.make,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((manual.model) = $event),
                class: "form-control form-control-sm",
                size: "10",
                onChange: ($event: any) => (editManuals(manual,$index))
              }, null, 40, _hoisted_12), [
                [
                  _vModelText,
                  manual.model,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((manual.serial) = $event),
                class: "form-control form-control-sm",
                size: "5",
                onChange: ($event: any) => (editManuals(manual,$index))
              }, null, 40, _hoisted_13), [
                [
                  _vModelText,
                  manual.serial,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            (isCheckOut())
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      onClick: ($event: any) => (setManualInteractedAndSeen(manual,$index)),
                      class: "form-check-input",
                      id: "seen",
                      type: "radio",
                      checked: manual.interacted && manual.seen
                    }, null, 8, _hoisted_15),
                    _hoisted_16
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      onClick: ($event: any) => (setManualInteractedAndNotSeen(manual,$index)),
                      class: "form-check-input",
                      id: "not_seen",
                      type: "radio",
                      checked: manual.interacted && !manual.seen
                    }, null, 8, _hoisted_17),
                    _hoisted_18
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                onClick: ($event: any) => (removeManual($index)),
                tabindex: "-1"
              }, _hoisted_21, 8, _hoisted_19)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewManual()))
    }, [
      _hoisted_22,
      _createTextVNode(" Manual ")
    ])
  ]))
}
}

})